import { applyMiddleware, createStore, compose, combineReducers } from 'redux';
import thunkMiddleware from 'redux-thunk';

import { userReducer } from '@zocdoc-frontend-common/state-user-account/reducers/userReducer';
import { signInFormReducer } from '@zocdoc-frontend-common/components-sign-in-form';

const composeEnhancers =
    (typeof window !== 'undefined' &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;

const initialStoreState = {
    user: null,
};

export function createReduxStore(initialState = initialStoreState) {
    return createStore(
        combineReducers({
            user: userReducer,
            signInForm: signInFormReducer,
        }),
        initialState,
        composeEnhancers(applyMiddleware(thunkMiddleware))
    );
}
